import { app } from '../../../../../../app';

app.service('EditProfileExtendedModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (profile) => {
        return $uibModal.open({
            component: 'editExtendedProfile',
            resolve: {
                phoneNumbers,
                profile: () => profile,
            }
        }).result;
    };
}

/** @ngInject */
function phoneNumbers(UserPhoneNumber) {
    return UserPhoneNumber.query().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/extended/edit/edit.modal.js